// A (possibly faster) way to get the current timestamp as an integer.
export default Date.now || function() {
  return new Date().getTime();
};



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/now.js
// module id = 208
// module chunks = 115